import { Injectable } from '@angular/core';
import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { DocumentTemplate } from '../models/document-template.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateService {

  constructor(private http: HttpClient, private apiService: ApiService) 
  { }
  public getAllDocumentTemplates(documentTemplateSearchParam:IGlobalSearchParam):Observable<any> {
    console.log(documentTemplateSearchParam);
    return this.apiService.post(`DocumentTemplate/SearchDocumentTemplate`,documentTemplateSearchParam)
  }

  public getDocumentTemplateById(docTemplateId:number):Observable<any> {
    return this.apiService.get(`DocumentTemplate/${docTemplateId}`)
}

public postDocumentTemplate(documentTemplate:DocumentTemplate):Observable<any> {
  return this.apiService.post(`DocumentTemplate`, documentTemplate)
}

public updateDocumentTemplate(docTemplateId:number, documentTemplate:DocumentTemplate):Observable<any> {
  return this.apiService.put(`DocumentTemplate/${docTemplateId}`, documentTemplate)
}

public deleteDocumentTemplate(docTemplateId:number):Observable<any> {
  return this.apiService.delete(`DocumentTemplate/${docTemplateId}`)
}


public ExportDocumentTemplate(documentTemplateSearchParam:IGlobalSearchParam):Observable<any> {
  return this.http.post(`${environment.apiRoot}DocumentTemplate/ExportDocumentTemplate`, documentTemplateSearchParam,
  {  
      responseType: 'blob',
      observe: 'response'
   });
  }

}
